module.exports = __webpack_public_path__ + "img/gongzhonghao.73c609c.png";